
import type { Database } from "@/integrations/supabase/types";

// RTL languages that need special handling
export const RTL_LANGUAGES = ["ar", "fa", "prs"];

// Map of language codes to their FPI PDF paths
export const FPI_PDF_MAP: Record<string, string> = {
  "sv": "/FPI_sv.pdf",
  "en": "/FPI_en.pdf", 
  "ar": "/FPI_ar.pdf",
  "fa": "/FPI_fa.pdf", 
  "prs": "/FPI_prs.pdf",
  "so": "/FPI_so.pdf",
  "ti": "/FPI_ti.pdf",
  "uk": "/FPI_uk.pdf"
};

// Common type for language support
export type SupportedLanguage = Database["public"]["Enums"]["supported_language"];

// Function to check if an FPI PDF exists for a language
export const checkFpiPdfExists = async (language: string): Promise<boolean> => {
  try {
    // Check if language has an FPI PDF defined
    const fpiPdfPath = FPI_PDF_MAP[language];
    if (!fpiPdfPath) {
      console.error(`No FPI PDF path defined for language: ${language}`);
      return false;
    }
    
    // Try to fetch the FPI PDF to check if it exists
    const response = await fetch(fpiPdfPath, { method: 'HEAD' });
    return response.ok;
  } catch (error) {
    console.error(`Error checking FPI PDF for language ${language}:`, error);
    return false;
  }
};

// Check if a language is RTL
export const isRtlLanguage = (language: string): boolean => {
  return RTL_LANGUAGES.includes(language);
};
